import { clickLinkAndDowload } from 'helpers/click-link-and-download.helper';

/**
 * @description Downloads a file to the user's device with cross-browser support
 *
 * @SADtrace SAD-003-5, SAD-003-6.6
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @param {any} data - The file data to download
 * @param {string} filename - The name to give the downloaded file
 * @param {string} [mime] - The MIME type of the file
 * @param {any} [bom] - Optional byte order mark
 *
 * @returns {void}
 */
const downloadFile = (
  data: any,
  filename: string,
  mime?: string,
  bom?: any,
) => {
  const blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
  const blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  // @ts-ignore
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    // @ts-ignore
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const blobURL =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }

    document.body.appendChild(tempLink);
    clickLinkAndDowload(tempLink);

    // Fixes "webkit blob resource error 1"
    setTimeout(() => {
      document.body.removeChild(tempLink);
      // Check if revokeObjectURL exists before calling it (JSDOM compatibility)
      // v8 ignore start -- WAIVER(ENV): JSDOM-compatibility guard around the window.URL object lifecycle; every real browser (and current jsdom) provides revokeObjectURL, so the negative arm has no environment to execute in
      if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
        // v8 ignore stop -- WAIVER(ENV)
        window.URL.revokeObjectURL(blobURL);
      }
    }, 200);
  }
};

export default downloadFile;
